(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Always make header sticky on desktop and mobile
      this.header.classList.add('shopify-section-header-sticky');
      
      // Force sticky on mobile - apply immediately
      const ensureMobileSticky = () => {
        if (window.matchMedia('(max-width: 989px)').matches) {
          this.header.style.position = 'sticky';
          this.header.style.top = '0';
          this.header.style.zIndex = '4';
          this.header.classList.add('shopify-section-header-sticky');
          this.header.classList.remove('shopify-section-header-hidden');
          
          // Also ensure header-wrapper is sticky
          const headerWrapper = this.querySelector('.header-wrapper');
          if (headerWrapper) {
            headerWrapper.style.position = 'sticky';
            headerWrapper.style.top = '0';
            headerWrapper.style.zIndex = '4';
          }
          
          // Also ensure sticky-header element itself is sticky
          this.style.position = 'sticky';
          this.style.top = '0';
          this.style.zIndex = '4';
        }
      };
      
      ensureMobileSticky();
      
      // Re-apply on resize
      window.addEventListener('resize', ensureMobileSticky);
      
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // On mobile, always keep header sticky - don't hide on scroll
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.header.style.position = 'sticky';
        this.header.style.top = '0';
        this.header.style.zIndex = '4';
        this.header.classList.add('shopify-section-header-sticky');
        this.header.classList.remove('shopify-section-header-hidden');
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // Always keep header visible - don't hide on scroll
      // Ensure sticky is maintained especially on mobile
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.header.style.position = 'sticky';
        this.header.style.top = '0';
        this.header.style.zIndex = '4';
      }
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    reveal() {
      // Always keep header visible - ensure sticky class is present
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.header.style.position = 'sticky';
        this.header.style.top = '0';
        this.header.style.zIndex = '4';
      }
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // Always keep header visible - ensure sticky class is present
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.header.style.position = 'sticky';
        this.header.style.top = '0';
        this.header.style.zIndex = '4';
      }
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
